import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    formsWrapper: 'flex center',
    trackOrderForm: 'md:max-w-lg lg:max-w-xl'
  },
  orderNumberLengths: (() => [8, 13]) as unknown as number[],
  showLoginCta: true
} satisfies RecursivePartial<PagesConfig['orderStatus']>
